import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import {
  AccountBalance,
  AgingReport,
  BalanceSheet,
  IncomeStatement,
  ScheduleFReport,
  TrialBalance,
} from '../../entities/accounting/report.entities';
import { BaseApiService } from '../api/base-api.service';
@Injectable({
  providedIn: 'root'
})
export class AccountingReportsService extends BaseApiService {

  getBalanceSheet(farmId: string, asOf?: Date): Observable<BalanceSheet> {
    let httpParams = new HttpParams();

    if (asOf) {
      httpParams = httpParams.set('as_of', asOf.toISOString());
    }

    return this.get<BalanceSheet>(`/farms/${farmId}/accounting/reports/balance-sheet`, httpParams);
  }

  getIncomeStatement(farmId: string, year: number): Observable<IncomeStatement> {
    const httpParams = new HttpParams().set('year', year.toString());

    return this.get<IncomeStatement>(`/farms/${farmId}/accounting/reports/income-statement`, httpParams);
  }

  getTrialBalance(farmId: string, asOf?: Date): Observable<TrialBalance> {
    let httpParams = new HttpParams();

    if (asOf) {
      httpParams = httpParams.set('as_of', asOf.toISOString());
    }

    return this.get<TrialBalance>(`/farms/${farmId}/accounting/reports/trial-balance`, httpParams);
  }

  getAccountBalance(farmId: string, accountCodeOrName: string, start?: Date, end?: Date): Observable<AccountBalance> {
    let httpParams = new HttpParams().set('account_code_or_name', accountCodeOrName);

    if (start) {
      httpParams = httpParams.set('start', start.toISOString());
    }
    if (end) {
      httpParams = httpParams.set('end', end.toISOString());
    }

    return this.get<AccountBalance>(`/farms/${farmId}/accounting/reports/account-balance`, httpParams);
  }

  getAgingReport(farmId: string, asOf: Date, accountCodes?: string[]): Observable<AgingReport> {
    let httpParams = new HttpParams();

    if (asOf) {
      httpParams = httpParams.set('as_of', asOf.toISOString());
    }
    if (accountCodes) {
      httpParams = httpParams.set('account_codes', accountCodes.join(','));
    }

    return this.get<AgingReport>(`/farms/${farmId}/accounting/reports/aging`, httpParams);
  }

  getScheduleF(farmId: string, year: number): Observable<ScheduleFReport> {
    const httpParams = new HttpParams().set('year', year.toString());

    return this.get<ScheduleFReport>(`/farms/${farmId}/accounting/reports/schedule-f`, httpParams);
  }
}
